export type AnimationVariants = 'slide-bottom-to-top';

export type AnimationVariantsOptions = {
  animationDuration: number;
  delay: number;
  numberOfTargets: number;
  isLooped?: boolean;
};

export function getAnimationVariants(
  animationVariant: AnimationVariants,
  {
    animationDuration,
    delay,
    numberOfTargets,
    isLooped,
  }: AnimationVariantsOptions
): Record<'from' | 'to', gsap.TweenVars> | null {
  const stagger = animationDuration + delay;
  const repeatDelay = stagger * (numberOfTargets - 1) + delay;

  if (animationVariant === 'slide-bottom-to-top') {
    return {
      from: {
        y: '100%',
        duration: animationDuration,
        ease: 'power1.inOut',
        stagger: {
          each: stagger,
          repeat: isLooped ? -1 : 0,
          repeatDelay: isLooped ? repeatDelay : NaN,
        },
      },
      to: {
        y: index =>
          !isLooped && index === numberOfTargets - 1 ? '0px' : '-100%',
        duration: animationDuration,
        ease: 'power1.inOut',
        stagger: {
          each: stagger,
          repeat: isLooped ? -1 : 0,
          repeatDelay: isLooped ? repeatDelay : NaN,
        },
      },
    };
  }

  return null;
}
